<div class="update-record-dialog">
  <section class="record-summary" aria-label="Job context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-wrench"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Edit Jobs</span>
      <h2>{{ technicalJobArray.length }} job{{ technicalJobArray.length !== 1 ? 's' : '' }} linked</h2>
    </div>
  </section>

  <div class="jobs-list" *ngIf="technicalJobArray.length; else noJobs">
    <article
      class="job-card"
      *ngFor="let job of technicalJobArray.controls; index as i"
    >
      <div class="job-card__header">
        <span>Job {{ i + 1 }}</span>
      </div>

      <app-job-form
        [inputFormGroup]="$any(job)"
        [selectedHotkey]="$any(job).get('job_description')?.value"
      ></app-job-form>
    </article>
  </div>

  <ng-template #noJobs>
    <div class="jobs-empty">
      <span>No jobs linked</span>
    </div>
  </ng-template>
</div>
